<div class="container p-2 bg-white rounded event-container">

  <!-- Event Image -->
  <div (mouseover)="animationEvent('in')" (mouseleave)="animationEvent('out')"
    [ngStyle]="{'background-image': 'url(' + productObject['EventProductExtraInfo']['image'] + ')'}" id="product-cover">
    <div class="p-2" id="product-cover-tag">
      <!--<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24" width="24">
      <g><rect fill="none" height="24" width="24" /></g>
      <g><path d="M15,3l2.3,2.3l-2.89,2.87l1.42,1.42L18.7,6.7L21,9V3H15z M3,9l2.3-2.3l2.87,2.89l1.42-1.42L6.7,5.3L9,3H3V9z M9,21 l-2.3-2.3l2.89-2.87l-1.42-1.42L5.3,17.3L3,15v6H9z M21,15l-2.3,2.3l-2.87-2.89l-1.42,1.42l2.89,2.87L15,21fs-6V15z" /></g>
      </svg>-->
      {{'Hover_for_full_size' | translate}}
    </div>
  </div>

  <div class="product-content">
    <!-- Info Bar -->
    <app-event-banner-details [startDay]="startDay" [endDay]="endDay" [productName]="productObject['productName']"
      [bussinessName]="businessObject?.name" [location]="eventLocation"
      [address]="eventAddress"></app-event-banner-details>

    <!-- Product Description -->
    <div class="payment-card mb-5">
      <div class="payment-card-header">{{ 'Buyer.Description' | translate }}</div>
      <div class="payment-card-body">
        <app-read-more textValue="{{ getNewProductValueByFieldName('description','ProductExtraInfos') }}">
        </app-read-more>
      </div>
    </div>

    <!-- Product Tickets -->
    <div class="payment-card mb-5">
      <div class="payment-card-header">{{ 'Buyer.Tickets' | translate }}</div>
      <div class="payment-card-body">
        <div id="TicketExample" *ngFor="let ticket of parsedTickets">
          <div class="row mx-0 align-items-center rounded Ticket" *ngIf="ticket.quantity > 0">

            <!-- Left part of the ticket. -->
            <div class="col-lg-5 p-3 TicketLeft">
              <div class="fs-6 mb-2 font-weight-bold">{{ticket.name}}</div>
              <div class="readmore-text-content" [innerHTML]="formatDescription(ticket.description)">
              </div>
              <hr class="TicketSidesSeparator" />
            </div>

            <!-- Right part of the ticket. -->
            <div class="col-lg-7 text-center p-3 TicketRight">
              <div class="row mx-0 align-items-baseline">
                <div class="col-lg-4 mt-4 mt-lg-0">
                  <div class="fs-6 mb-2 font-weight-bold">{{ 'Buyer.Type' | translate }}</div>
                  <div style="font-size: .8rem;">{{ticket.name || 'N/A'}}</div>
                </div>
                <div class="col-lg-4 mt-4 mt-lg-0 px-0">
                  <div class="mb-2">{{ 'Buyer.Quantity' | translate }}</div>
                  <div style="transform: scale(.8);" class="row mx-0 justify-content-center">
                    <button class="col-3 px-0 btn-ticket"
                      (click)="quantityDownChange($event, ticket.name, ticket.price, ticket.id , ticket.maxQuantityPerSale, 'prev')"
                      type="button" onclick="this.nextElementSibling.stepDown()">
                      -
                    </button>
                    <input type="number" min="0" max="{{ticket.maxQuantityPerSale}}" value="0" readonly
                      class="col-6 px-0 form-number-control text-center" />
                    <button class="col-3 px-0 btn-ticket"
                      (click)="quantityUpChange($event, ticket.name, ticket.price, ticket.id, ticket.maxQuantityPerSale, 'next')"
                      type="button" onclick="this.previousElementSibling.stepUp()">
                      +
                    </button>
                  </div>
                </div>
                <div class="col-lg-4 mt-4 mt-lg-0 px-0">
                  <div class="fs-6 mb-2 font-weight-bold">{{ 'Buyer.Price' | translate }}</div>
                  <div style="font-size: .8rem;">
                    {{
                    basePrice(ticket.price,getNewProductValueByFieldName('currency','ProductExtraInfos')).toFixed(2)}}
                    {{ getNewProductValueByFieldName('currency','ProductExtraInfos') }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mx-0 align-items-center rounded mx-4 mx-lg-0 Ticket" *ngIf="ticket.quantity<=0">

            <!-- Left part of the ticket. -->
            <div class="col-lg-5 col-xl-5 p-3 TicketLeft">
              <div class="fs-6 mb-2 font-weight-bold">{{ticket.name}}</div>
              <div style="font-size: .8rem;">{{ticket.description || 'Buyer.NoDescription' | translate}}</div>
              <hr class="TicketSidesSeparator" />
            </div>

            <!-- Right part of the ticket. -->
            <div class="col-lg-7 col-xl-7 text-center p-3 TicketRight">
              <div class="row mx-0 align-items-baseline">
                <div class="col-sm-12 col-md-12 col-lg-5 col-xl-5 mt-4 mt-lg-0">
                  <div class="fs-6 mb-2 font-weight-bold">{{ 'Buyer.Type' | translate }}</div>
                  <div style="font-size: .8rem;">{{ticket.name || 'N/A'}}</div>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 mt-4 mt-lg-0">
                  <p class="soldOut">{{ 'Buyer.SoldOut' | translate }}</p>
                </div>
              </div>
            </div>
          </div>
          <br>
        </div>
        <div class="text-end mt-3">
          <span class="fs-5">{{ 'Buyer.Total' | translate }}: </span>
          <span class="text-primary fs-4">
            {{ subtotal.toFixed(2) }}
            {{ getNewProductValueByFieldName('currency','ProductExtraInfos') }}
          </span>
        </div>
      </div>
    </div>

    <!-- Ads -->
    <div class="mb-4">
      <!--<app-ads [productObject]="productObject"></app-ads>-->
    </div>

    <div class="row justify-content-end">
      <div class="col-lg-4 col-md-6 row">
        <button class="btn btn-primary" type="button" [disabled]="subtotal <= 0" (click)="proceedToPayment()">{{
          'Buyer.Next' | translate }}</button>
      </div>
    </div>
  </div>
  <app-event-terms-section *ngIf="productObject" [eventTerms]="eventTermsObject"></app-event-terms-section>
</div>
